// extracted by mini-css-extract-plugin
export default {"homepage":"HomePage_homepage__5IjsE","homepage__title":"HomePage_homepage__title__ULKq-"};